// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ASld0","fullView":"styles_fullView__3XMpb"};